<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between mb-4">
      <div class="section-title">
        {{ $t("view") }} {{ $t("customerloyaltyponits") }}
      </div>
      <!-- <div class="section-subTitle my-2">Manage all Customer Loyalty Points</div> -->
      <div>
        <router-link
          variant="default"
          class="btn-blue p-2"
          to="customer-loyalty-points"
          >{{ $tc("list", 1) }} {{ $t("customerloyaltyponits") }}</router-link
        >
      </div>
    </div>

    <!-- LIST VIEW DESIGNATION -->
    <div class="white-wrapper">
      <div class="swc-report">
        <div class="font-weight-bold">{{ $t("customer") }} {{ $t("name") }} : <span class="fs-16">{{ cust_name }}</span></div>
        <div class="font-weight-bold">Total Loyality Points:&nbsp;&nbsp; <span class="fs-16">{{ total_points || 0 }}</span></div>
        <div class="float-right mb-2">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
        <br />
        <table
          class="swc-report-table"
          v-if="type === 'boxoffice' || type == 'both'"
        >
          <thead class="dark_back">
            <tr>
              <th>{{ $t("booking") }} {{ $t("code") }}</th>
              <th>{{ $t("show") }} {{ $t("date") }} {{ $t("time") }}</th>
              <th>{{ $t("transaction") }} {{ $t("date") }} {{ $t("time") }}</th>
              <th>{{ $t("totalamount") }}</th>
              <th>{{ $t("earnpoints") }}</th>
              <th>{{ $t("burnpoints") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(transactionlist,
              transactionlistIndex) in customertransactions"
              :key="transactionlistIndex"
              class="light_grey_back"
            >
              <td class="text-left">{{ transactionlist.sb_booking_code }}</td>
              <td>
                {{ transactionlist.t_show_date | dateparse }} -
                {{ transactionlist.t_show_time | convertTo12Hours }}
              </td>
              <td>
                {{ transactionlist.t_booking_date_time | fulldaydateparse }}
              </td>
              <td class="text-right">{{ transactionlist.sb_total_amount }}</td>
              <td class="text-right">
                {{
                  transactionlist.earnings_points
                    ? transactionlist.earnings_points
                    : 0
                }}
              </td>
              <td class="text-right">
                {{
                  transactionlist.burnings_points
                    ? transactionlist.burnings_points
                    : 0
                }}
              </td>
            </tr>
            <tr>
              <td colspan="4"></td>
              <td>
                <strong
                  >Total Earn Points :
                  {{
                    customertransactions && customertransactions.length > 0
                      ? customertransactions.reduce(
                          (ac, x) => (ac += x.earnings_points),
                          0
                        )
                      : "-"
                  }}</strong
                >
              </td>
              <td>
                <strong
                  >Total Burn Points :
                  {{
                    customertransactions && customertransactions.length > 0
                      ? customertransactions.reduce(
                          (ac, x) => (ac += x.burnings_points),
                          0
                        )
                      : "-"
                  }}</strong
                >
              </td>
            </tr>
            <tr>
              <td colspan="4"></td>
              <td colspan="2">
                <strong>Total Points : {{ customertransactions && customertransactions.length > 0
                      ? customertransactions.reduce(function(
                          accumulator,
                          { earnings_points, burnings_points }
                        ) {
                          return accumulator + parseFloat(earnings_points || 0) - parseFloat(burnings_points || 0);
                        },
                        0)
                      : "-" }}</strong>
              </td>
            </tr>
          </tbody>
        </table>
        <table class="swc-report-table" v-if="type === 'fnb' || type == 'both'">
          <thead class="dark_back">
            <tr>
              <th>{{ $t("order") }} {{ $t("code") }}</th>
              <th>{{ $t("transaction") }} {{ $t("date") }} {{ $t("time") }}</th>
              <th>{{ $t("totalamount") }}</th>
              <th>{{ $t("earnpoints") }}</th>
              <th>{{ $t("burnpoints") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(transactionlist,
              transactionlistIndex) in customertransactions"
              :key="transactionlistIndex"
              class="light_grey_back"
            >
              <td>{{ transactionlist.order_code }}</td>
              <td>{{ transactionlist.ft_date_time | fulldaydateparse }}</td>
              <td class="text-right">
                {{ transactionlist.ft_gross_amount_before_offer }}
              </td>
              <td class="text-right">
                {{
                  transactionlist.earnings_points
                    ? transactionlist.earnings_points
                    : 0
                }}
              </td>
              <td class="text-right">
                {{
                  transactionlist.burnings_points
                    ? transactionlist.burnings_points
                    : 0
                }}
              </td>
            </tr>
            <tr>
              <td colspan="3"></td>
              <td>
                <strong
                  >Total Earn Points :
                  {{
                    customertransactions && customertransactions.length > 0
                      ? customertransactions.reduce(
                          (ac, x) => (ac += x.earnings_points),
                          0
                        )
                      : "-"
                  }}</strong
                >
              </td>
              <td>
                <strong
                  >Total Burn Points :
                  {{
                    customertransactions && customertransactions.length > 0
                      ? customertransactions.reduce(
                          (ac, x) => (ac += x.burnings_points),
                          0
                        )
                      : "-"
                  }}</strong
                >
              </td>
            </tr>
            <tr>
              <td colspan="3"></td>
              <td colspan="2">
                <strong>Total Points : {{ customertransactions && customertransactions.length > 0
                      ? customertransactions.reduce(function(
                          accumulator,
                          { earnings_points, burnings_points }
                        ) {
                          return accumulator + parseFloat(earnings_points || 0) - parseFloat(burnings_points || 0);
                        },
                        0)
                      : "-" }}</strong>
              </td>
            </tr>
          </tbody>
        </table>
         <table class="swc-report-table" v-if="type === 'admin'">
          <thead class="dark_back">
            <tr>
              <th>Transaction Code</th>
              <th>{{ $t("transaction") }} {{ $t("date") }} {{ $t("time") }}</th>
              <th>{{ $t("totalamount") }}</th>
              <th>Credited Points</th>
              <th>Deducted Points</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(transactionlist,
              transactionlistIndex) in customertransactions"
              :key="transactionlistIndex"
              class="light_grey_back"
            >
              <td>{{ transactionlist.loyalty_trx_id }}</td>
              <td>{{ transactionlist.created_at | fulldaydateparse }}</td>
              <td class="text-right">
                {{ parseFloat(0).toFixed(this.MIN_FRACTION_DIGITS) }}
              </td>
              <td class="text-right">
                {{
                  transactionlist.earnings_points
                    ? transactionlist.earnings_points
                    : 0
                }}
              </td>
              <td class="text-right">
                {{
                  transactionlist.burnings_points
                    ? transactionlist.burnings_points
                    : 0
                }}
              </td>
            </tr>
            <tr>
              <td colspan="3"></td>
              <td>
                <strong
                  >Total Earn Points :
                  {{
                    customertransactions && customertransactions.length > 0
                      ? customertransactions.reduce(
                          (ac, x) => (ac += x.earnings_points),
                          0
                        )
                      : "-"
                  }}</strong
                >
              </td>
              <td>
                <strong
                  >Total Burn Points :
                  {{
                    customertransactions && customertransactions.length > 0
                      ? customertransactions.reduce(
                          (ac, x) => (ac += x.burnings_points),
                          0
                        )
                      : "-"
                  }}</strong
                >
              </td>
            </tr>
            <tr>
              <td colspan="3"></td>
              <td colspan="2">
                <strong>Total Points : {{ customertransactions && customertransactions.length > 0
                      ? customertransactions.reduce(function(
                          accumulator,
                          { earnings_points, burnings_points }
                        ) {
                          return accumulator + parseFloat(earnings_points || 0) - parseFloat(burnings_points || 0);
                        },
                        0)
                      : "-" }}
                      </strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MarketingService from "@/services/MarketingService";

export default {
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      viewingnumbers: [],

      customertransactions: [],
      cust_name: "",
      total_points: "",
      type: ""
    };
  },
  beforeMount() {
    const { clp_id, type } = this.$route.query;
    this.type = type;
    if (type == "both") {
      this.getCustomerLoyaltyPointsBYID(clp_id, "fnb");
      this.getCustomerLoyaltyPointsBYID(clp_id, "boxoffice");
    } else {
      this.getCustomerLoyaltyPointsBYID(clp_id, type);
    }
    this.getviewingnumber();
  },
  methods: {
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 }
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    onChangePagination: function(event) {
      const { clp_id, type } = this.$route.query;
      if (event === undefined) {
        this.currentPage = 1;
        this.getCustomerLoyaltyPointsBYID(clp_id, type);
      } else {
        this.currentPage = event;
        this.getCustomerLoyaltyPointsBYID(clp_id, type);
      }
    },

    getCustomerLoyaltyPointsBYID: function(id, type) {
      this.customertransactions = [];
      let payload = {
        clp_id: id,
        limit: this.perPage,
        currentPage: this.currentPage,
        type
      };

      MarketingService.GetCustomerLoyaltyPointsBYID(payload)
        .then(response => {
          console.log("response :", response);
          const { data } = response;

          if (data.status) {
            if (data.Records && data.Records.length > 0) {
              this.cust_name =
                data.Records[0].first_name + " " + data.Records[0].last_name;
              this.total_points = data.Records[0].points;
              this.customertransactions = data.Records;

              if (data.totalRows && data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else if (data.totalRows) {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    }
  }
};
</script>

<style scoped>
.swc-report .swc-report-table thead th,
td {
  border: 1px solid #000000;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/CustomerLoyaltyPointsComponents/viewcustomerloyaltypoints.vue